import React, { useContext, useEffect } from 'react';
import "../Loading/loading.css";
import { ThemeContext } from '../../contexts/ThemeContext';

const Loading = () => {
  const { isDarkMode } = useContext(ThemeContext);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);
  
  return (
    <div className="loading-overlay">
      <div className="loading-spinner">
        <img src="/logo-movie.svg" alt="Movie Logo" className="loading-logo" />
      </div>
    </div>
  );
};

export default Loading;
